import axios from 'axios';

const baseURL = import.meta.env.VITE_API_BASE_URL ?? 'https://draco.access.wicketsoft.com/api'; // this is here temporarily for deployment purposes until i figure out how to inject this into the build process

const axiosClient = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' }
});

export { axiosClient };
